import React, { useState } from "react";
import { useNavigate } from "react-router-dom";


import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MuiDialogAlert from '../components/MuiDialogAlert';
import LoadingOverlay from 'react-loading-overlay';




import { useUserAuth } from "../context/UserAuthContext";


function Login(props) {
    const [email, setEmail] = useState("");

    const [loadingActive, setLoadingActive] = useState(false);
    const [loadingMsg, setLoadingMsg] = useState("Processing ...");

    const [modalBody, setModalBody] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState("");

    const handleClose = () => setShowModal(false);

    const { resetPassword } = useUserAuth();
    const navigate = useNavigate();

    async function processReset(e) {
        //e.preventDefault();

        try {
            setLoadingActive(true);
            resetPassword(email).then(response => {
                setModalHeader("Email Sent")
                setModalBody(`An email with instructions to reset your password has been sent to ${email}.\nIf it does not arrive, kindly check your spam folder.`);
                setShowModal(true);
                setLoadingActive(false);
            }).catch(e => {
                if (e.message === "Firebase: Error (auth/user-not-found)."){
                    setModalHeader("Invalid Email")
                    setModalBody(`This account does not exist`);
                    setShowModal(true);
                    setLoadingActive(false);
                }

            })
        }
        catch (err) {
            setModalHeader("Error")
            setModalBody(err.message);
            setShowModal(true);
            setLoadingActive(false);
        }

    }

    return (
        <div align="center" style={{ height: "100vh" }}>

            <LoadingOverlay
                active={loadingActive}
                spinner
                text={loadingMsg}
                className="spinner_div"
            >

                <div align="center" className='title_header'>RESET PASSWORD</div>
                <div style={{ width: "500px" }}>
                    <div style={{ height: "30px" }}></div>

                    <div className='f_18px'>
                        Enter your authorized email to receive instructions on how to reset your password.
                    </div>

                    <div style={{ height: "30px" }}></div>

                    <TextField
                        id="username"
                        onChange={(e) => setEmail(e.target.value)}
                        variant="outlined"
                        value={email}
                        label="Email"
                        sx={{ width: 300}}
                    />

                    <div style={{ height: "20px" }}></div>


                    <div>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={processReset}
                            sx={{ width: 200, height: 50 }}
                        >
                            Send Email
                        </Button>
                    </div>

                    <div style={{ height: "20px" }}></div>

                    <div><a href="/">Login Page</a></div>


                    <MuiDialogAlert
                        showModal={showModal}
                        handleClose={handleClose}
                        bodyContent={modalBody}
                        title={modalHeader}
                        bodyClass="whitespace"
                    />


                </div>

            </LoadingOverlay>




        </div>
    )
}

export default Login